import { useCallback, useState } from 'react';

/**
 * toggle 상태 관리를 위한 중복 코드를 커스텀 훅으로 분리합니다.
 *
 * 사용법 >
 *
 * ```
 * import { useToggleState } from '@kc-console/core';
 * ...
 * const [checked, toggle] = useToggleState();
 * return <ToggleButton checked={checked} onClick={toggle} />;
 * ```
 *
 * @param defaultValue toggle 상태의 기본값을 설정합니다.
 * @returns bool (boolean), toggle (() => void)
 */
function useToggleState(defaultValue = false): readonly [boolean, (next?: boolean) => void] {
  const [bool, setBool] = useState<boolean>(defaultValue);

  const toggle = useCallback((next?: boolean) => {
    if (typeof next === 'boolean') {
      setBool(next);
      return;
    }

    setBool(prevBool => !prevBool);
  }, []);

  return [bool, toggle] as const;
}

export default useToggleState;
